import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import type { PrivacyPolicySection } from "./types";

const { Title, Text } = Typography;

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const sections = t("privacyPolicy.sections", {
    returnObjects: true,
  }) as Record<string, PrivacyPolicySection>;

  return (
    <div className="px-5 mt-5">
      <Title level={1} className="mb-3">
        {t("privacyPolicy.title")}
      </Title>
      <Title level={5} className="mb-3">
        {t("privacyPolicy.intro")}
      </Title>
      {Object.values(sections).map((section) => (
        <div className="mb-3" key={section.title}>
          <Title level={5}>{section.title}</Title>
          <Text>{section.content}</Text>
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
